import { render, staticRenderFns } from "./addServeXieYiGuanLi.vue?vue&type=template&id=ef1a8e80&scoped=true&"
import script from "./addServeXieYiGuanLi.vue?vue&type=script&lang=js&"
export * from "./addServeXieYiGuanLi.vue?vue&type=script&lang=js&"
import style0 from "./addServeXieYiGuanLi.vue?vue&type=style&index=0&id=ef1a8e80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1a8e80",
  null
  
)

export default component.exports